import axios from 'axios';

export const modulesApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/module`,
    headers: {
        'Content-Type': 'application/json'
    }
})